import login1 from '../../../../shared/img/ppt/login1.png';
import assistance from '../../../../shared/img/ppt/assistance.png';

const addSlide7 = (pptx, addBrandingToSlide) => {
  // presentation slide
  const slide7 = pptx.addSlide({ masterName: 'COMPANY_BRANDING' });
  slide7.addText('ASSISTANCE EN LIGNE', {
    x: 1.25,
    y: 0.25,
    w: 8,
    h: 0.5,
    align: 'center',

    // Style du texte
    fontSize: 22,
    color: '4f4f4f',
    bold: true,

    // Style de la forme
    shape: pptx.ShapeType.rect,
    fill: { color: 'fae3f2' },

    // Bordure
    line: {
      color: 'f71616', // rouge foncé
      width: 1, // épaisseur de la bordure
    },
  });

  slide7.addImage({
    path: login1,
    x: 0.5,
    y: 1,
    w: 4,
    h: 2,
  });

  slide7.addText([
    { text: 'Cliquez sur le bouton "Besoin d\'aide? Assistance" si ', options: { color: '696969' } },
    { text: 'vous rencontrez des difficultés', options: { bold: true, color: '696969' } },
    { text: ' pour accéder à la plateforme', options: { color: '696969' } },
  ], {
    x: 5,
    y: 1,
    w: 4.8,
    h: 1,
    shape: pptx.ShapeType.rect,
    fill: { color: 'ffffff' },
    wrap: true,
    fontSize: 14,
    line: {
      color: 'FF0000',
      width: 1,
    },
  });

  slide7.addImage({
    path: assistance,
    x: 0.5,
    y: 3.2,
    w: 4,
    h: 2,
  });

  slide7.addText(
    [
      { text: 'Dans les cas suivants, merci de contacter directement notre service d\'assistance :\n', options: { bold: true, color: '696969' } },
      { text: 'Si vous rencontrez des difficultés avec l\'utilisation de la plateforme', options: { bullet: true, indentLevel: 1, color: '696969' } },
      { text: 'Si vous avez des questions concernant la réalisation de l\'e-learning, le programme, les modalités d\'évaluations…', options: { bullet: true, indentLevel: 1, color: '696969' } },
      { text: 'Pour cela, rendez-vous sur l\'onglet «', options: { color: '696969' } },
      { text: 'HELP', options: { bold: true, color: '696969' } },
      { text: '» de votre compte et cliquez sur le bouton «', options: { color: '696969' } },
      { text: 'Accéder à l\'assistance', options: { bold: true, color: '696969' } },
      { text: '». \n', options: { color: '696969' } },
      { text: 'Vous y trouverez un ', options: { color: '696969' } },
      { text: 'formulaire à compléter ', options: { bold: true, color: '696969' } },
      { text: 'pour contacter notre service technique.', options: { color: '696969' } },
    ],
    {
      x: 5,
      y: 2.1,
      w: 4.8,
      h: 3.5,
      fontSize: 14,
      shape: pptx.ShapeType.rect,
      fill: { color: 'ffffff' },
      line: { color: 'FF0000', width: 1 },
    },
  );

  addBrandingToSlide(pptx, slide7);
};

export default addSlide7;
